







//import { ResponseModel } from "@dataSource/models/responseModels.ts";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({ name: "ui-dropdown-menu"})
export default class UiDropdownMenuComponent extends Vue {
 @Prop({default:false})
 visible:boolean
 
 @Prop({default:20})
 margin:number

 innerShow:boolean = this.visible;
 x:number=0;
 y:number=0;

 created() {
    document.body.addEventListener("click", this.clickOutside.bind(this));
  }
  clickOutside(event: any) {
    
    if (!(this.$el == event.target || this.$el.contains(event.target))) {
      //this.hide()
    }
  }

 show(e: MouseEvent){
  //  console.log("show drop menu")
    this.innerShow = true;
 }

 hide(){
  this.innerShow =false
 }

  @Watch("visible")
  onVisibleChange(){
    this.innerShow=this.visible;
  }
  
  // destroyed() {
  //   document.body.removeEventListener("click", this.clickOutside.bind(this));
  // }


}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./~/dropdown-menu/src/ui-dropdown-menu.vue